import React from 'react';
import { useWebSocketListener } from '../../context/useWebSocketListener';
import { WEB_SOCKET_ENTITY_TYPES } from '../../utils/WebSocketUtils';

const WalkthroughDetailListener = ({ socketContext, onMessage, entityIds }) => {
	useWebSocketListener({
		socketContext,
		onMessage,
		entityName: WEB_SOCKET_ENTITY_TYPES.WALKTHROUGH,
		entityIds,
	});
	return null;
};

export default WalkthroughDetailListener;
